module.exports = __webpack_public_path__ + "img/compact.8141cc1f.png";